import { SiteHeader } from '@/components/site-header'
import { Hero } from '@/components/hero'
import { CreatorVideos } from '@/components/creator-videos'
import { Features } from '@/components/features'
import { SupportedRadios } from '@/components/supported-radios'
import { GetStarted } from '@/components/get-started'
import { Download } from '@/components/download'
import { DocsCommunity } from '@/components/docs-community'
import { SiteFooter } from '@/components/site-footer'

export default function Page() {
  return (
    <div className="min-h-screen">
      <SiteHeader />
      <main>
        <Hero />
        <CreatorVideos />
        <Features />
        <SupportedRadios />
        <GetStarted />
        <Download />
        <DocsCommunity />
      </main>
      <SiteFooter />
    </div>
  )
}
